




































import { Vue, Component, Watch } from 'vue-property-decorator';
import CommonDialog from '../../components/organisms/CommonDialog.vue';
import { LessonDTO } from '../../../src_server/entity/dto/LessonDTO';
import { dayjs, DT_FORMAT_INPUT, DT_FORMAT, DTW_FORMAT_JA_SHORT } from '../../../src_server/common/momentExtends';
import { MessageDialog } from '../../utils/MessageDialog';
import { LessonsTransferService } from '../../biz/remote/LessonsTransferService';
import { Session } from '../../utils/Session';
@Component({
  components: { CommonDialog },
  filters: {
    format(d: Date) {
      return dayjs(d).format(DTW_FORMAT_JA_SHORT);
    },
  },
})
export default class TransferDialog extends Vue {
  dto!: LessonDTO;

  day1 = '';
  day2: string | null = null;
  day3: string | null = null;

  private nickname = '';

  private statDt = dayjs();

  get endT() {
    return this.statDt.add(50, 'minute').format('HH時mm分');
  }

  @Watch('dto', { deep: true })
  setInitChangeDate() {
    console.log('setInitChangeDate');
    const datetime = dayjs(this.dto?.lessons?.start_dt);
    this.day1 = datetime.format(DT_FORMAT_INPUT);
    // this.day2 = datetime.format(DT_FORMAT_INPUT);
    // this.day3 = datetime.format(DT_FORMAT_INPUT);
  }

  hide(no: number) {
    console.log(no);
    if (no === 2) this.day2 = null;
    if (no === 3) this.day3 = null;
  }

  open(no: number) {
    const datetime = dayjs(this.dto?.lessons?.start_dt);
    if (no === 2) this.day2 = datetime.format(DT_FORMAT_INPUT);
    if (no === 3) this.day3 = datetime.format(DT_FORMAT_INPUT);
  }

  isDuplicateTime(time1: string | null, time2: string | null) {
    if (time1 && time2) {
      if (Math.abs(dayjs(time1).diff(time2, 'minute')) < 50) return true;
    }
    return false;
  }

  async transferRequest() {
    if (!this.dto?.lessons) {
      MessageDialog.alert(`レッスンが取得できませんでした。`).then(() => location.reload());
      return;
    }
    const day1dj = dayjs(this.day1);
    if (this.isDuplicateTime(this.day1, this.day2)) {
      MessageDialog.alert('時間帯が重複しています。');
      return;
    }
    if (this.isDuplicateTime(this.day1, this.day3)) {
      MessageDialog.alert('時間帯が重複しています。');
      return;
    }
    if (this.isDuplicateTime(this.day2, this.day3)) {
      MessageDialog.alert('時間帯が重複しています。');
      return;
    }

    const isOK = await MessageDialog.confirm(`リクエストをキャンセルして振替依頼を通知します。よろしいですか？`);
    if (isOK) {
      const biz = new LessonsTransferService();
      const days = [];
      days.push(day1dj.format(DT_FORMAT));
      if (this.day2) {
        const day2dj = dayjs(this.day2);
        console.log('diff dt', day1dj, day2dj, day2dj.diff(day1dj, 'minute'));
        days.push(day2dj.format(DT_FORMAT));
      }
      if (this.day3) {
        const day3dj = dayjs(this.day3);
        days.push(day3dj.format(DT_FORMAT));
      }

      biz.transferRequest(this.dto?.lessons, days, Session.getSessionBuildingId()).then(() => {
        MessageDialog.alert(`リクエストをキャンセルし、振替依頼を通知しました。`).then(() => {
          this.close();
          this.$emit('transfered', this.dto);
        });
      });
    }
  }

  public async show(defaultDt: Date, dto: LessonDTO) {
    console.log('dialog ', defaultDt, dto);
    this.dto = dto;
    this.statDt = dayjs(defaultDt);
    this.nickname = this.dto?.student?.nickname || '';

    this.setInitChangeDate();
    this.day1 = dayjs(defaultDt).format(DT_FORMAT_INPUT);
    this.day2 = null;
    this.day3 = null;

    (this.$refs['dialog'] as CommonDialog).show();
  }

  public close() {
    (this.$refs['dialog'] as CommonDialog).hide();
  }
}
